import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../assets/icon3.png";
import Navbar from "../components/Navbar/Navbar";
import Footer from "./../components/Footer/footer";
import bg from "../assets/bg.png";
import Farmer from "../components/Farmer";
const Referral: React.FC = () => {
  const navigate = useNavigate();

  const navigateToWallet = () => {
    navigate("/connectwallet"); // Use history.push to navigate to the '/mintpage' route
  };
  return (
    <div
      className="p-3 bg-fixed bg-center bg-no-repeat flex flex-col min-h-screen"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <Farmer />
      <Navbar />
      <div className="flex-grow">
        <div className="max-w-faqMax-width flex-grow w-full mx-auto bg-gradient-bg from-opacity-5 to-opacity-0 rounded-2xl p-3 md:p-5 md:px-8 text-white flex flex-col gap-2 mt-2 lg:mt-4">
          <h1 className="text-white text-24 md:text-xl font-bold tracking-tracking1">
            REFER A FRIEND
          </h1>
          <p className="text-dark_white text-base">
            Invite your friends to mint NFT and earn a 20% commission. You can
            claim your earnings at any time!
          </p>
          <p className="text-white text-base">
            Before you get referral link, please connect your wallet.
          </p>
          <button
            onClick={navigateToWallet}
            className="w-full bg-vibrant_yellow text-center rounded-xl text-black font-semibold text-sm uppercase p-3 my-3"
          >
            CONNECT WALLET
          </button>
          <hr className="max-w-hrMax-width w-full h-px mx-auto border border-transparent_200 my-2 " />
          <h2 className="text-lg md:text-xl font-bold tracking-tracking2 uppercase">
            summary
          </h2>
          <p className="text-transparent_500 text-sm">
            Data is displayed for the following network.
          </p>
          <div className="flex items-center gap-4">
            <img src={Icon} alt="icon" />
            <p className="text-white font-medium text-base">
              Arbitrum
              <span className="text-transparent_500 font-normal"> Network</span>
            </p>
          </div>
          <hr className=" w-full h-px mx-auto border border-transparent_200 my-4 " />
          <div className="flex justify-start gap-4 flex-col md:flex-row">
            <div className="flex-1">
              <h4 className="text-base font-normal text-white opacity-50">
                Claimed
              </h4>
              <hr className="w-3 border border-transparent_200 my-4 " />
              <p className="text-transparent_300 text-base font-normal">0.00</p>
            </div>
            <div className="flex-1">
              <h4 className="text-base font-normal text-white opacity-50">
                Unclaimed
              </h4>
              <hr className="w-3 border border-transparent_200 my-4 " />
              <p className="text-transparent_300 text-base font-normal">0.00</p>
            </div>
            <div className="flex-1">
              <h4 className="text-base font-normal text-white opacity-50">
                Mints
              </h4>
              <hr className="w-3 border border-transparent_200 my-4 " />
              <p className="text-transparent_300 text-base font-normal">0.00</p>
            </div>
          </div>
          <hr className=" w-full h-px mx-auto border border-transparent_200 my-4 " />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Referral;
